import { Navigate, useNavigate } from "react-router-dom";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useUser } from "../../context/api.js";
import { setActivity, setMilestone, useHomework } from "../../context/homework";
import MDBox from "../../components/MDBox";
import activities from "../../components/activities";
import React, { useState } from "react";
import CorrectionDisplay from "./correction-display.js";

function Activity() {
  const user = useUser();
  const navigate = useNavigate();
  const [homework, dispatch] = useHomework();
  const [activityId, setActivityId] = useState(null);
  const activity =
    homework.activity &&
    homework.activity.activityType &&
    activities[homework.activity.activityType];

  const onEnd = (activityId) => {
    if (homework.activity.milestoneId) {
      setMilestone(dispatch, homework.activity.milestoneId, user.id, null);
    }
    if (activity.Corrector && activityId) {
      // We want to display the result
      setActivityId(activityId);
    } else {
      setActivity(dispatch, null);
      navigate("/", { replace: true });
    }
  };

  if (!activity) {
    return <Navigate to="/" replace />;
  }

  const Executor = activity.Executor;
  const Corrector = activity.Corrector;

  return (
    <PageLayout>
      <MDBox display="flex" alignItems="center" justifyContent="center" width="100%" height="100vh">
        {!activityId && <Executor params={homework.activity} onEnd={onEnd} />}
        {!!activityId && (
          <CorrectionDisplay Corrector={Corrector} activityId={activityId} onEnd={onEnd} />
        )}
      </MDBox>
    </PageLayout>
  );
}

export default Activity;
